import api from '@/api'
import store from '@/store'
import D2C_Entity from './Entity'

class D2C_Container extends D2C_Entity {
  target = 'container'
  static objectType = 'entityType'
  static typeName = 'container'
  static statuses = {
    OFFLINE: 'OFFLINE',
    ONLINE: 'ONLINE',
    RESTARTING: 'RESTARTING',
  }
  static processes = {
    DESTROYING: 'DESTROYING',
    EXECUTING: 'EXECUTING',
    MOVING_COMMIT: 'MOVING_COMMIT',
    MOVING_CONFIRMATION: 'MOVING_CONFIRMATION',
    MOVING_ROLLBACK: 'MOVING_ROLLBACK',
    MOVING: 'MOVING',
    QUEUED: 'QUEUED',
    RESTARTING: 'RESTARTING',
    STARTING: 'STARTING',
    STOPPING: 'STOPPING',
  }
  static actions = {
    RESTART: 'RESTART',
    START: 'START',
    STOP: 'STOP',
  }
  static stats = {
    cpu: {},
    mem: {},
  }
  static fields = {
    hosts: {
      default: [],
      label: 'Hosts',
      selector: {
        default: [],
      },
      validate(value) {
        if (!value.length) {
          return 'Must be selected at least one host'
        }
        return null
      },
      moving: {
        required: true,
      },
    },
  }
  static create(props) {
    return new D2C_Container(props)
  }
  get _alias() {
    let containerName = `${this.name}`
    if (/^.*-([0-9]+)$/.test(containerName)) {
      const part = containerName.split('-');
      part.pop();
      containerName = part.join('-');
    }
    if (this.role !== 'node') {
      containerName = `${containerName}-${this.role}`;
    }
    return containerName;
  }
  get _host() {
    return store.getters.hostsById[this.host]
  }
  get _project() {
    return store.getters.projectsById[this._service.project]
  }
  get _service() {
    return store.getters.servicesById[this.service]
  }
  get _logo() {
    const service = this._service
    return service ? service._logo : ''
  }
  get _isRestarting() {
    return this.status === this.constructor.statuses.RESTARTING
  }
  get _isMoving() {
    return this.process === this.constructor.processes.MOVING_CONFIRMATION
  }
  get _isOnline() {
    return this.status === this.constructor.statuses.ONLINE
  }
  get _isOffline() {
    return this.status === this.constructor.statuses.OFFLINE
  }
  get _inProgress() {
    const service = this._service
    return Boolean(this.process) || Boolean(service && service.process)
  }
  get _stats() {
    return Object.assign({}, this.constructor.stats, store.state.containerStats[this.id])
  }
  get _endpoint() {
    const service = this._service
    const {protocol, value} = service.ports[0] || {}
    if (!service.remoteAccess || protocol === 'UDP' || !value) {
      return null
    }
    const host = this._host
    const portString = (value === 80 || value === 443) ? '' : `:${value}`
    const protocolString = value === 443 ? 'https:' : 'http:';
    return `${protocolString}//${host.ipAddress}${portString}`
  }
  applyAction(action) {
    return api.applyContainerAction(this.id, action)
  }
  restart() {
    return this.applyAction(this.constructor.actions.RESTART)
  }
  start() {
    return this.applyAction(this.constructor.actions.START)
  }
  stop() {
    return this.applyAction(this.constructor.actions.STOP)
  }
  destroy() {
    return api.destroyContainer(this.id)
  }
  cancelTask() {
    return api.cancelContainerTask(this.id)
  }
  fetchLogs(filter) {
    return api.fetchContainerLogs(this.id, filter)
  }
  fetchStats(filter) {
    return api.fetchContainerStats(this.id, filter)
  }
  execCommands(data = {}) {
    return api.execContainerCommands(this.id, data)
  }
  move(hostId) {
    return api.moveContainer(this.id, hostId)
  }
  moveConfirm() {
    return api.moveContainerConfirm(this.id)
  }
  moveCancel() {
    return api.moveContainerCancel(this.id)
  }
  subscribeStats() {
    api.subscriptions.containerStats[this.id] = api.subscriptions.containerStats[this.id] ? api.subscriptions.containerStats[this.id] + 1 : 1
    api.subscriptions.updateContainerStats()
  }
  unsubscribeStats() {
    api.subscriptions.containerStats[this.id] = api.subscriptions.containerStats[this.id] ? api.subscriptions.containerStats[this.id] - 1 : 0
    api.subscriptions.updateContainerStats()
  }
}

export default D2C_Container
